import * as React from 'react';
import * as reg from "./style.module.scss";
import { Timer } from "../Timer";
export const Reg = ({ id, widget }) => {
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.container}>
          <div className={reg.info}>
            <h2>До вебинара осталось:</h2>
            <Timer id={id} block={'reg'}/>
            <div className={reg.gift}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/gift.svg" alt=""/>
              <div className={reg.textBlock}>
                <p>Запишитесь и получите в подарок мини-курс «100 английских слов для путешествий за 2 часа»</p>
                <p>Онлайн-курс для тех, кто хочет быстро и надолго запоминать иностранные слова без зубрежки</p>
              </div>
            </div>
          </div>
          <div className={reg.form} id={'widget'}>
            { widget }
          </div>
        </div>
      </div>
    </section>
  );
};
